// eslint-disable-next-line import/no-extraneous-dependencies
import semver from 'semver';

export default (clientVersion, deprecateVersion) => {
  let client = clientVersion;
  const dash = client.indexOf('-');
  if (dash > -1) {
    client = client.substring(0, dash);
  }
  return semver.gte(client, deprecateVersion);
};
